import { Project, GalleryImage } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const projects: Project[] = [
  // Completed Projects
  {
    id: 'catfight',
    title: 'CATFIGHT',
    subtitle: 'Award-Winning LGBTQ+ Drama',
    year: '2023',
    status: 'completed',
    genre: 'Drama / LGBTQ+',
    description: 'A light-hearted love story with a twist of gender non-discrimination. CATFIGHT depicts the true love and hate relationship between two friends SONIYA and VEDICA since their childhood. The film explores how social stigma restricts LGBT individuals from expressing their sentiments, love, affection, and belongingness.',
    image: IMAGES.CATFIGHT_MOVIE_POSTER_2_168,
    cast: ['Umang Bhadana', 'Arshin Mehta'],
    awards: [
      '109+ International Film Festival Awards',
      'Best Director - Multiple Festivals',
      'Best LGBTQ+ Film',
      'Best Short Film',
      'Silver Award - Hollywood Independent Filmmaker Awards',
      'Winner - Vesuvius International Film Festival',
      'Golden Elephant Awards Nominee 2024',
    ],
    highlights: [
      'Shot across Canada, India, and United States',
      'Runtime: 39 minutes 39 seconds',
      'Languages: English, Hindi',
      'Critically acclaimed worldwide',
    ],
    website: 'https://r39zsfpb3h.skywork.website',
  },
  {
    id: 'jeena-isi-ka-naam-hai',
    title: 'Jeena Isi Ka Naam Hai',
    year: '2017',
    status: 'completed',
    genre: 'Drama / Entertainment',
    description: 'A Bollywood entertainer with universal issues directed by Keshhav Panneriy. This feature film stars Arbaaz Khan, Ashutosh Rana, Himansh Kohli, Manjari Phadnis, and Prem Chopra, exploring themes that resonate across cultures.',
    image: IMAGES.JEENA_ISI_KA_NAAM_HAI_POSTER_1_162,
    cast: [
      'Arbaaz Khan',
      'Ashutosh Rana',
      'Himansh Kohli',
      'Manjari Phadnis',
      'Prem Chopra',
    ],
    highlights: [
      '$6M USD feature production',
      'Multi-starrer Bollywood cast',
      'Universal themes with Indian storytelling',
      'Theatrical release',
    ],
    watchLinks: {
      amazonPrime: 'https://www.primevideo.com/region/eu/detail/0HG49KPOU9ZBC5F42F3GH04QEW/ref=atv_dp_share_cu_r',
      youtube: 'https://youtu.be/yArir1D9lzU?si=w4RV8zu_DVfzxE8o',
    },
  },

  // Upcoming Projects
  {
    id: 'chaos',
    title: 'CHAOS',
    subtitle: 'International Geopolitical Thriller',
    year: '2026',
    status: 'upcoming',
    genre: 'Action Thriller / Geopolitical',
    description: 'The app that could trigger World War III. A darkly comic action thriller about an AI defense app that becomes the catalyst for global conflict. Shot across India, USA, Canada, France, UK, and Israel with extensive CGI and VFX work spanning over 70 minutes of high-quality visual effects.',
    image: IMAGES.CHAOS_MAIN_POSTER_178,
    cast: [
      'Gulshan Grover',
      'Sunny Leone',
      'Arbaaz Khan',
      'Jagapathi Babu',
      'International ensemble cast',
    ],
    highlights: [
      'Shot across 6 countries (India, USA, Canada, France, UK, Israel)',
      '70+ minutes of high-quality VFX and CGI',
      'AI-powered defense technology theme',
      'Global geopolitical intrigue',
      'Timely and relevant to current world events',
      'International co-production',
    ],
    website: 'https://afratafri-movie.com',
  },
  {
    id: 'pc-cinematic-universe',
    title: 'PC Cinematic Universe',
    subtitle: 'The Six-Volume Epic Saga',
    year: '2026-2030',
    status: 'in-production',
    genre: 'Epic Saga / Cinematic Universe',
    description: 'An ambitious six-volume cinematic universe that creates an interconnected narrative spanning multiple films. This groundbreaking project establishes a new paradigm in Indian cinema with Hollywood-level production values and storytelling.',
    image: IMAGES.PC_POSTER_PNG_177,
    highlights: [
      'Six interconnected feature films',
      'Multi-year production timeline',
      'Hollywood-level production values',
      'Expansive world-building',
      'International distribution strategy',
      'Franchise potential',
    ],
  },
  {
    id: 'kc',
    title: 'KC',
    year: '2026',
    status: 'upcoming',
    genre: 'Drama / Thriller',
    description: 'An upcoming cinematic project from Bibia Films Studios directed by Keshhav Panneriy. KC promises to deliver a compelling narrative with powerful performances and cutting-edge production values.',
    image: IMAGES.KC_POSTER_176,
    highlights: [
      'Directed by Keshhav Panneriy',
      'Contemporary storytelling',
      'High production values',
      'International appeal',
    ],
  },
  {
    id: 'hello-london',
    title: 'Hello London',
    year: '2026',
    status: 'upcoming',
    genre: 'Drama / Romance',
    description: 'A contemporary drama exploring cross-cultural relationships and identity in the modern world. Set against the backdrop of London, this film brings together international talent and perspectives.',
    image: IMAGES.FILM_CREW_5,
    cast: ['Karan Singh Grover', 'International ensemble'],
    highlights: [
      'International locations',
      'Cross-cultural storytelling',
      'Contemporary themes',
      'Streaming release planned for March 2026',
    ],
  },
];

export const galleryImages: GalleryImage[] = [
  // Studio Facilities
  {
    id: 'studio-entrance-1',
    title: 'Studio Main Entrance',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_MAIN_ENTERANCE_1_29,
    description: 'Professional studio entrance with backlit signage and film poster displays',
  },
  {
    id: 'studio-entrance-2',
    title: 'Studio Entrance Lobby',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_MAIN_ENTERANCE_2_30,
    description: 'Cinematic entrance showcasing studio branding and creative identity',
  },
  {
    id: 'reception-area',
    title: 'Reception & Welcome Area',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_RECEPTION_WELCOME_AREA_1_32,
    description: 'Modern reception with dramatic lighting and contemporary design',
  },
  {
    id: 'shooting-floor-1',
    title: 'Multi-Utility Shooting Floor',
    category: 'production',
    image: IMAGES.BIBIA_STUDIOS_MULTIUTILITY_SHOOTING_CROMA_FLOOR_1_105,
    description: 'Professional chroma key studio with flexible lighting systems',
  },
  {
    id: 'shooting-floor-2',
    title: 'Chroma Key Setup',
    category: 'production',
    image: IMAGES.BIBIA_STUDIOS_MULTIUTILITY_SHOOTING_CROMA_FLOOR_2_104,
    description: 'Green screen studio ready for VFX and virtual production',
  },
  {
    id: 'shooting-floor-3',
    title: 'Production Floor',
    category: 'production',
    image: IMAGES.BIBIA_STUDIOS_MULTIUTILITY_SHOOTING_CROMA_FLOOR_3_103,
    description: 'Versatile shooting space with professional lighting rigs',
  },

  // Post-Production
  {
    id: 'main-editing-suite',
    title: 'Main Editing & Color Grading Suite',
    category: 'post-production',
    image: IMAGES.BIBIA_STUDIOS_MAIN_BOSS_EDITING_ROOM_1_108,
    description: 'High-performance editing workstation with 4K/8K monitoring',
  },
  {
    id: 'editing-suite-2',
    title: 'Premium Editing Suite',
    category: 'post-production',
    image: IMAGES.BIBIA_STUDIOS_MAIN_BOSS_EDITING_ROOM_2_107,
    description: 'Professional editing environment with multi-monitor setup',
  },
  {
    id: 'editing-suite-3',
    title: 'Color Grading Station',
    category: 'post-production',
    image: IMAGES.BIBIA_STUDIOS_MAIN_BOSS_EDITING_ROOM_3_106,
    description: 'Dedicated color grading suite with calibrated displays',
  },
  {
    id: 'editorial-workspace-1',
    title: 'Editorial Workspace',
    category: 'post-production',
    image: IMAGES.BIBIA_STUDIOS_EDITING_ROOM_GENERAL_1_100,
    description: 'Comfortable editing room for extended post-production sessions',
  },
  {
    id: 'editorial-workspace-2',
    title: 'Assistant Editor Station',
    category: 'post-production',
    image: IMAGES.BIBIA_STUDIOS_EDITING_ROOM_GENERAL_2_101,
    description: 'Additional editing workspace for parallel workflows',
  },

  // Meeting Rooms & Offices
  {
    id: 'executive-meeting-1',
    title: 'Executive Producer Suite',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_BOSS_KESHHAV_S_PERSONAL_MEETING_ROOM_1_33,
    description: 'Premium meeting space for high-level production discussions',
  },
  {
    id: 'executive-meeting-2',
    title: 'Boardroom',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_BOSS_KESHHAV_S_PERSONAL_MEETING_ROOM2_34,
    description: 'Strategic command center for creative planning',
  },
  {
    id: 'executive-meeting-3',
    title: 'Conference Room',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_BOSS_KESHHAV_S_PERSONAL_MEETING_ROOM_3_35,
    description: 'Sophisticated meeting environment with presentation systems',
  },
  {
    id: 'ep-meeting-1',
    title: 'EP Meeting Room',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_EP_MEETING_ROOM_1_36,
    description: 'Collaborative space for executive producers and directors',
  },
  {
    id: 'production-office-1',
    title: 'Production Coordination Room',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_ASSISTANTS_DIRECTOR_PLUS_PRODUCTION_ROOM_1_110,
    description: 'Operational hub for assistant directors and production teams',
  },

  // Behind the Scenes - Production
  {
    id: 'bts-crew-1',
    title: 'Film Crew on Set',
    category: 'behind-scenes',
    image: IMAGES.FILM_CREW_1,
    description: 'Professional film crew during production',
  },
  {
    id: 'bts-crew-2',
    title: 'Director and Cinematographer',
    category: 'behind-scenes',
    image: IMAGES.FILM_CREW_2,
    description: 'Collaborative filmmaking in action',
  },
  {
    id: 'bts-crew-3',
    title: 'Camera Department',
    category: 'behind-scenes',
    image: IMAGES.FILM_CREW_3,
    description: 'Professional camera operators at work',
  },
  {
    id: 'bts-set-1',
    title: 'On Set Production',
    category: 'production',
    image: IMAGES.MOVIE_SET_1,
    description: 'Active film set with full crew',
  },
  {
    id: 'bts-set-2',
    title: 'Filming in Progress',
    category: 'production',
    image: IMAGES.MOVIE_SET_2,
    description: 'Professional production environment',
  },

  // Post-Production Work
  {
    id: 'post-work-1',
    title: 'Editing Session',
    category: 'post-production',
    image: IMAGES.POST_PRODUCTION_1,
    description: 'Professional editor working on timeline',
  },
  {
    id: 'post-work-2',
    title: 'Color Grading Work',
    category: 'post-production',
    image: IMAGES.POST_PRODUCTION_2,
    description: 'Precision color grading in progress',
  },
  {
    id: 'post-work-3',
    title: 'Post-Production Suite',
    category: 'post-production',
    image: IMAGES.POST_PRODUCTION_3,
    description: 'State-of-the-art post-production facility',
  },

  // Support Facilities
  {
    id: 'kitchen-area',
    title: 'Kitchen & Pantry',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_KITCHEN_PANTRY_AREA_1_102,
    description: 'Fully equipped kitchen for long production days',
  },
  {
    id: 'storage-1',
    title: 'Equipment Storage',
    category: 'studio',
    image: IMAGES.BIBIA_STUDIOS_UTILITY_PLUS_STORAGE_ROOM_1_38,
    description: 'Organized storage for production equipment',
  },

  // Behind the Scenes - Film Production (Recently Added)
  {
    id: 'bts-arbaaz-keshhav',
    title: 'Director with Lead Actor',
    category: 'behind-scenes',
    image: IMAGES.ARBAAZ_KESHHAV,
    description: 'Keshhav Panneriy directing Arbaaz Khan on set',
  },
  {
    id: 'bts-ak-discussion',
    title: 'Actor Discussion',
    category: 'behind-scenes',
    image: IMAGES.AK,
    description: 'Intense discussion between actors during scene preparation',
  },
  {
    id: 'bts-ak1-scene',
    title: 'Scene Rehearsal',
    category: 'behind-scenes',
    image: IMAGES.AK1,
    description: 'Actors rehearsing dialogue and blocking',
  },
  {
    id: 'bts-crew-tiger-1',
    title: 'Blue Screen Production with Tiger',
    category: 'production',
    image: IMAGES.IMG_96A8891,
    description: 'Professional crew filming with live tiger on blue screen set',
  },
  {
    id: 'bts-crew-tiger-2',
    title: 'Director with Crew and Tiger',
    category: 'behind-scenes',
    image: IMAGES.BFS0064,
    description: 'Keshhav Panneriy directing complex animal scene with full crew',
  },
  {
    id: 'bts-crew-tiger-3',
    title: 'VFX Production Setup',
    category: 'production',
    image: IMAGES.BFS0083,
    description: 'Blue screen setup for visual effects integration',
  },
  {
    id: 'bts-bedroom-scene-1',
    title: 'Interior Scene Production',
    category: 'production',
    image: IMAGES.BFS5176,
    description: 'Filming dramatic bedroom scene with natural lighting',
  },
  {
    id: 'bts-bedroom-scene-2',
    title: 'Intimate Scene Direction',
    category: 'behind-scenes',
    image: IMAGES.BFS5257,
    description: 'Director guiding actors through emotional scene',
  },
  {
    id: 'bts-location-shoot-1',
    title: 'Location Filming',
    category: 'production',
    image: IMAGES.BFS6524,
    description: 'On-location production with professional crew',
  },
  {
    id: 'bts-location-shoot-2',
    title: 'Outdoor Production',
    category: 'production',
    image: IMAGES.BFS7035,
    description: 'Exterior filming with natural light setup',
  },
  {
    id: 'bts-action-scene-1',
    title: 'Action Sequence Setup',
    category: 'production',
    image: IMAGES.BFS9512,
    description: 'Preparing for high-intensity action sequence',
  },
  {
    id: 'bts-action-scene-2',
    title: 'Stunt Coordination',
    category: 'behind-scenes',
    image: IMAGES.BFS9534,
    description: 'Director coordinating with stunt team',
  },
  {
    id: 'bts-dramatic-scene-1',
    title: 'Dramatic Performance',
    category: 'production',
    image: IMAGES.BFS9677,
    description: 'Capturing powerful dramatic moment',
  },
  {
    id: 'bts-dramatic-scene-2',
    title: 'Emotional Scene',
    category: 'behind-scenes',
    image: IMAGES.BFS9764,
    description: 'Director working with actors on emotional beats',
  },
  {
    id: 'bts-dramatic-scene-3',
    title: 'Character Interaction',
    category: 'production',
    image: IMAGES.BFS9905,
    description: 'Filming intense character confrontation',
  },
  {
    id: 'bts-dramatic-scene-4',
    title: 'Scene Blocking',
    category: 'behind-scenes',
    image: IMAGES.BFS9907,
    description: 'Blocking and rehearsing complex scene choreography',
  },
  {
    id: 'bts-interior-1',
    title: 'Interior Set Production',
    category: 'production',
    image: IMAGES.DSC6717,
    description: 'Professional interior set with controlled lighting',
  },
  {
    id: 'bts-interior-2',
    title: 'Indoor Scene Filming',
    category: 'production',
    image: IMAGES.DSC6774,
    description: 'Multi-camera setup for interior scene',
  },
  {
    id: 'bts-dialogue-1',
    title: 'Dialogue Scene',
    category: 'behind-scenes',
    image: IMAGES.R_1902,
    description: 'Actors delivering powerful dialogue',
  },
  {
    id: 'bts-dialogue-2',
    title: 'Conversation Scene',
    category: 'production',
    image: IMAGES.R_1918,
    description: 'Filming intimate conversation between characters',
  },
  {
    id: 'bts-performance-1',
    title: 'Actor Performance',
    category: 'behind-scenes',
    image: IMAGES.R_2523,
    description: 'Capturing nuanced performance',
  },
  {
    id: 'bts-performance-2',
    title: 'Dramatic Moment',
    category: 'production',
    image: IMAGES.R_2634,
    description: 'Filming pivotal dramatic moment',
  },
  {
    id: 'bts-performance-3',
    title: 'Character Development',
    category: 'behind-scenes',
    image: IMAGES.R_2713,
    description: 'Director working on character arc',
  },
  {
    id: 'bts-performance-4',
    title: 'Scene Execution',
    category: 'production',
    image: IMAGES.R_2732,
    description: 'Professional execution of complex scene',
  },
  {
    id: 'bts-action-4',
    title: 'Action Filming',
    category: 'production',
    image: IMAGES.R_4500,
    description: 'High-energy action sequence in progress',
  },
  {
    id: 'bts-action-5',
    title: 'Dynamic Scene',
    category: 'behind-scenes',
    image: IMAGES.R_4502,
    description: 'Capturing dynamic movement and action',
  },
  {
    id: 'bts-production-1',
    title: 'Production Day',
    category: 'production',
    image: IMAGES.IMG_084A1973,
    description: 'Full crew during active production',
  },
  {
    id: 'bts-production-2',
    title: 'Filming Session',
    category: 'behind-scenes',
    image: IMAGES.IMG_084A1990,
    description: 'Professional filming session with complete crew',
  },
  {
    id: 'bts-production-3',
    title: 'Set Operations',
    category: 'production',
    image: IMAGES.IMG_084A1997,
    description: 'Coordinated set operations during shoot',
  },
  {
    id: 'bts-production-4',
    title: 'Production Workflow',
    category: 'behind-scenes',
    image: IMAGES.IMG_084A2011,
    description: 'Efficient production workflow in action',
  },
  {
    id: 'bts-production-5',
    title: 'Scene Setup',
    category: 'production',
    image: IMAGES.IMG_084A2041,
    description: 'Setting up for next scene',
  },
  {
    id: 'bts-camera-work-1',
    title: 'Camera Department',
    category: 'production',
    image: IMAGES.IMG_084A8088,
    description: 'Professional camera operators at work',
  },
  {
    id: 'bts-camera-work-2',
    title: 'Cinematography',
    category: 'behind-scenes',
    image: IMAGES.IMG_084A8097,
    description: 'Cinematographer framing the perfect shot',
  },
  {
    id: 'bts-camera-work-3',
    title: 'Camera Setup',
    category: 'production',
    image: IMAGES.IMG_084A8476,
    description: 'Advanced camera rigging and setup',
  },
  {
    id: 'bts-shoot-1',
    title: 'Active Shooting',
    category: 'production',
    image: IMAGES.IMG_148A0415,
    description: 'Cameras rolling during active shoot',
  },
  {
    id: 'bts-shoot-2',
    title: 'Scene Capture',
    category: 'behind-scenes',
    image: IMAGES.IMG_148A0458,
    description: 'Capturing the perfect take',
  },
  {
    id: 'bts-shoot-3',
    title: 'Production Moment',
    category: 'production',
    image: IMAGES.IMG_148A0465,
    description: 'Key production moment on set',
  },
  {
    id: 'bts-shoot-4',
    title: 'Filming Process',
    category: 'behind-scenes',
    image: IMAGES.IMG_148A0519,
    description: 'Professional filming process',
  },
  {
    id: 'bts-shoot-5',
    title: 'Set Activity',
    category: 'production',
    image: IMAGES.IMG_148A0521,
    description: 'Busy set with multiple departments working',
  },
  {
    id: 'bts-shoot-6',
    title: 'Production Scene',
    category: 'behind-scenes',
    image: IMAGES.IMG_148A0524,
    description: 'Professional production scene',
  },
  {
    id: 'bts-shoot-7',
    title: 'Filming Day',
    category: 'production',
    image: IMAGES.IMG_148A0850,
    description: 'Full day of professional filming',
  },
  {
    id: 'bts-location-3',
    title: 'Location Work',
    category: 'production',
    image: IMAGES.IMG_3O4A0817,
    description: 'On-location production work',
  },
  {
    id: 'bts-location-4',
    title: 'Exterior Shoot',
    category: 'behind-scenes',
    image: IMAGES.IMG_3O4A1348,
    description: 'Exterior location filming',
  },
  {
    id: 'bts-location-5',
    title: 'Outdoor Production',
    category: 'production',
    image: IMAGES.IMG_3O4A1635,
    description: 'Professional outdoor production',
  },
  {
    id: 'bts-location-6',
    title: 'Location Scene',
    category: 'behind-scenes',
    image: IMAGES.IMG_3O4A1797,
    description: 'Filming on unique location',
  },
  {
    id: 'bts-location-7',
    title: 'Set Location',
    category: 'production',
    image: IMAGES.IMG_3O4A2192,
    description: 'Professional set on location',
  },
  {
    id: 'bts-location-8',
    title: 'Location Filming',
    category: 'behind-scenes',
    image: IMAGES.IMG_3O4A2200,
    description: 'Active filming on location',
  },
  {
    id: 'bts-final-1',
    title: 'Production Wrap',
    category: 'production',
    image: IMAGES.IMG_3O4A9868,
    description: 'Final scenes of production day',
  },
  {
    id: 'bts-final-2',
    title: 'Wrap Scene',
    category: 'behind-scenes',
    image: IMAGES.IMG_3O4A9870,
    description: 'Wrapping up successful shoot',
  },
  {
    id: 'bts-screenshot',
    title: 'Production Monitor',
    category: 'behind-scenes',
    image: IMAGES.SCREEN_SHOT_2016,
    description: 'Director reviewing footage on production monitor',
  },
];